import React from 'react';
import QueryDetails from './querydetails';
import ComplaintManagementDetails from './ComplaintManagementDetails';
import './complaintmanagement.css';

const ShowTablePage = () => {
  return (
    <main className="ca-query-management-page">
      <QueryDetails />
      <ComplaintManagementDetails />
    </main>
  );
};

export default ShowTablePage;